export default {"src":"/_next/static/media/UBS.0934c531.svg","height":18,"width":18};